
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pools/[address]",
      function () {
        return require("private-next-pages/pools/[address]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pools/[address]"])
      });
    }
  